import { action, observable } from 'mobx';
import stores from 'cd-eft/models/Stores';
import MessageCenter from 'cd-eft/components/common/MessageCenter/MessageCenterVM';
const setStore = stores.AppStore.surveyEngineeringStore;

export class PointTranslationByDeltaVM {
  @observable shouldDisplayOnMap = false;
  @observable props;
  constructor(props: any) {
    this.props = props;
  }

  // form Validation ->
  @action.bound errorClass(field) {
    const errorMessage = this.formValidation.formErrors[field];
    return errorMessage.length === 0 ? '' : ' usa-input--error';
  }

  @observable formValidation = {
    formErrors: {
      deltaX: '',
      deltaY: '',
      deltaZ: '',
    },
  };

  resetErrors() {
    for (const key in this.formValidation.formErrors) {
      this.formValidation.formErrors[key] = '';
      if (setStore[key] === '') {
        setStore[key] = 0;
      }
    }
  }

  @action.bound async handleInputChange(e) {
    const { name, value } = e.target;
    const label = e.target.getAttribute('data-label');
    this.resetErrors();
    this.props.setFormError('');
    setStore.doRotate = false;
    setStore[name] = value;
    await this.validateField(name, value, label);
  }

  @action.bound onBlur(e) {
    const { name, value } = e.target;
    if (value === '') {
      setStore[name] = 0;
      this.formValidation.formErrors[name] = '';
    } else {
      const numVal = Number.parseFloat(value);
      setStore[name] = numVal;
      this.formValidation.formErrors[name] = '';
    }
  }

  @action.bound async validateField(name, value, label) {
    const formErrors = this.formValidation.formErrors;
    if (value === '') {
      const message = await MessageCenter.addErrorLabelFromCode('Survey_19'); // must be a number.
      formErrors[name] = label + message;
    } else if (value === 0) {
      formErrors[name] = '';
    } else {
      formErrors[name] = '';
    }
  }
  // <- form Validation
}
